import { render } from "./RuiSidebar.vue?vue&type=template&id=59e6f859&scoped=true"
import script from "./RuiSidebar.vue?vue&type=script&lang=ts"
export * from "./RuiSidebar.vue?vue&type=script&lang=ts"

import "./RuiSidebar.vue?vue&type=style&index=0&id=59e6f859&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-59e6f859"

export default script